import { formatMillisToTime } from './formatMillisToTime';

export const formatAverageMillisToTime = (
  milliseconds: number | null | undefined
): string => {
  if (milliseconds == null) {
    return '-';
  }

  const roundedMilliseconds = Math.round(milliseconds / 1000) * 1000;
  return formatMillisToTime(roundedMilliseconds);
};
